import React, { useState, useEffect } from 'react';
import { CssBaseline, AppBar, Toolbar } from '@material-ui/core';
import { useLocation } from 'react-router';
import NeoWrapperDrawer from './neo-wrapper-drawer/neo-wrapper-drawer';
import useNeoWrapperStyles from './neo-wrapper.styles';
import NeoWrapperModules from './neo-wrapper-modules/neo-wrapper-modules';
import NeoWrapperDrawerContext from './neo-wrapper-drawer/neo-wrapper-drawer.context';
import NeoWrapperDefaultTopBar from './neo-wrapper-default-top-bar/neo-wrapper-default-top-bar';
import Logout from '../logout/logout';

export const SCROLL_CONTAINER_ID = 'scroll-container';

interface NeoWrapperProps {
  children?: React.ReactElement | React.ReactElement[],
  getMenuOptions: Function,
  journeyId: string
}

const NeoWrapper: React.FC<NeoWrapperProps> = ({
  journeyId,
  getMenuOptions,
  children
}) => {
  const classes = useNeoWrapperStyles();
  const location = useLocation();

  // const [hideModules] = useState(false);
  // const [hideAllModules] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (): void => setIsDrawerOpen(!isDrawerOpen);
  const closeDrawer = (): void => setIsDrawerOpen(false);

  const getPageTitle = (): string => {
    return getMenuOptions().find(menuOption => menuOption.selected)?.title;
  };

  const renderDrawerContent = (): JSX.Element | null => {
    // if (hideModules) {
    //   return <Logout />;
    // }

    // if (hideAllModules) {
    //   return <></>;
    // }

    return <NeoWrapperModules journeyId={journeyId} menuOptions={getMenuOptions()}/>;
  };

  useEffect(() => {
    (document.getElementById(SCROLL_CONTAINER_ID) as HTMLDivElement).scrollIntoView();
  }, [location.pathname]);  // eslint-disable-line

  return (
    <NeoWrapperDrawerContext.Provider
      value={{
        isOpen: isDrawerOpen,
        closeDrawer,
        toggleDrawer
      }}
    >
      <div className={classes.root}>
        <CssBaseline />
        <AppBar className={classes.appbar}>
          <Toolbar className={classes.toolbar}>
            <NeoWrapperDefaultTopBar title={getPageTitle()}  journeyId={journeyId} />
          </Toolbar>
        </AppBar>
        <NeoWrapperDrawer>
          {renderDrawerContent()}
        </NeoWrapperDrawer>
        {getPageTitle() === "E-Sign"?
         (
          <main className={classes.eSignContent} id={SCROLL_CONTAINER_ID}>
            {children}
          </main>
         )
         : 
         (
          <main className={classes.contentContainer} id={SCROLL_CONTAINER_ID}>
          <div className={classes.content}>
            <div className={`${classes.contentInner} baselineOverride`}>
              {children}
            </div>
          </div>
        </main>
         )}
      </div>
    </NeoWrapperDrawerContext.Provider>
  );
};

export default NeoWrapper;